export default function getCustomAttr(arrData,textValue) {
    let dataValue = "";
    // console.log(textValue,arrData)
    arrData.map(data => {
        if( data.name.toLowerCase() === textValue.toLowerCase() ){
            dataValue = data.value;
        }
    })
    return dataValue;
}